import { Header } from "@/presentation";
import { Form } from "@/presentation/components/Forms/Form/Form";
import { AppDrawer } from "@/presentation/components/layout/AppDrawer/AppDrawer";
import { useAuthContext } from "@/presentation/context";
import { useSimple } from "@/presentation/hooks/useSimple";
import { routes } from "@/presentation/router";
import { getTableName } from "@/shared/utils/tableTranslator";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function NuevoSimple() {


  

  const navigate = useNavigate();
  const { user, logout } = useAuthContext();
  const { tabla } = useParams();
  const titulo = getTableName(String(tabla));

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleOpenDrawer = () => {
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };

  const handleLogout = async () => {
    await logout();
    setIsDrawerOpen(false);
    navigate(routes.login, { replace: true });
  };

  const { create } = useSimple(tabla as string);

  const handleSubmitValues = async (
    values: Record<string, unknown>
  ) => {
    const simple = {
      nombre: String(values.nombre),
      descripcion: String(values.descripcion ?? ""),
    };
    await create(simple);
    navigate(routes.dashboard);
  };




   

  return (
    <div>
      <Header title={`Nuevo ${titulo}`} onMenuClick={handleOpenDrawer} />

      <AppDrawer
        isOpen={isDrawerOpen}
        user={user}
        onClose={handleCloseDrawer}
        onLogout={handleLogout}
      />

      <main style={{ padding: '24px' }}>
        <Form
          fields={[
            {
              name: 'nombre',
              label: 'Nombre',
              type: 'text',
            },
            {
                name: 'descripcion',
                label: 'Descripción',
                type: 'textarea',
                optional: true,
            }
            
          ]}
          
          
          submitLabel={
            `Crear ${titulo}`
          }
          onSubmit={handleSubmitValues}
          
        />
        

      </main>


    </div>
  );
}

